// composables/useConfirm.ts
import { push } from 'notivue'

export function useConfirm() {
  const confirm = async (message: string, options: {
    title?: string
    confirmText?: string
    cancelText?: string
  } = {}) => {
    return new Promise<boolean>((resolve) => {
      const notification = push.success({
        title: options.title || 'Confirm',
        message,
        duration: 0, // Persistent until action
        actions: [
          {
            label: options.cancelText || 'Cancel',
            onClick: () => {
              notification.destroy() // Dismiss on cancel
              resolve(false)
            }
          },
          {
            label: options.confirmText || 'Confirm',
            onClick: () => {
              notification.destroy() // Dismiss on confirm
              resolve(true)
            }
          }
        ]
      })
    })
  }

  return { confirm }
}